// src/components/VerifyDeposit.js
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const VerifyDeposit = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const user = searchParams.get('user');
    const key = searchParams.get('key');
    if (user && key) {
      axios.get(`https://api.blackroq.pro/api/verify-deposit?user=${user}&key=${key}`)
        .then(() => window.location.href = '/dashboard')
        .catch(() => window.location.href = '/deposit?error=verify');
    } else {
      window.location.href = '/deposit';
    }
  }, [searchParams]);

  return <div>Vérification en cours…</div>;
};

export default VerifyDeposit;